import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';
import { useParams } from 'react-router-dom';

import { useGetCohortsQuery } from '@verantos-dev/data-access-cohorts';
import { type Cohort } from '@verantos-dev/types-cohorts';
import { ListResponse } from '@verantos-dev/types-common';

export const useCohortsDataGridFetch: TypedUseQueryHookResult<
  ListResponse<Cohort>,
  string | null,
  any,
  any
> = () => {
  const { projectId, urlParams } = useParams<{ projectId: string; urlParams: string }>();
  return useGetCohortsQuery(
    { projectId: projectId || '', urlParams: urlParams || '' },
    {
      pollingInterval: 5000, // 5 seconds
    }
  );
};
